import { Action, createReducer, on } from '@ngrx/store';
import { IConfigState } from './config';
import {
  RETRIEVE_CONFIG_SUCCESS,
  RETRIEVE_EXPIRED_OBJECT_SUCCESS,
  RETRIEVE_NOTIFICATIONS_SUCCESS,
  RETRIEVE_REGEX_DHL_SUCCESS,
  RETRIEVE_SHOW_SURVEY,
  RETRIEVE_SURVEY_SUCCESS,
  SET_IS_LOTTOMATICA,
} from './config.actions';
import { Config } from '../../interfaces/config';

/* INITIAL STATE */
const initialState: IConfigState = {
  isLottomatica: false,
  isNotificationPresent: false,
  regexCodiceDhlInbound: '',
  regexCodiceDhlInboundCodeSeparator: '',
  surveyUrl: '',
  abilitato: false,
  frequenzaPopupOggettiScaduti: 0,
  giornataLavorativa: false,
  numeroOgettiScadutiOggi: 0,
  numeroOgettiScadutiPrimaDiOggi: 0,
  oggettiScadutiOggi: false,
  oggettiScadutiPrimaDiOggi: false,
  numberOfResultsPerPage: 0,
  giorniAnticipoFerie: 0,
  messaggioHeader: null,
  nuovaComunicazione: null,
  timerForLoginFocus: null,
  isRedirectForFocusEnabled: false
};

const handleSaveNotifications = (
  state: IConfigState,
  { isNotificationPresent, messaggioHeader, nuovaComunicazione }: { isNotificationPresent: boolean, messaggioHeader?: string, nuovaComunicazione?: string }
): IConfigState => {
  return {
    ...state,
    isNotificationPresent,
    messaggioHeader: messaggioHeader || null,
    nuovaComunicazione: nuovaComunicazione || null
  };
};

const handleSetIsLottomatica = (
  state: IConfigState,
  { isLottomatica }: { isLottomatica: boolean }
): IConfigState => {
  return {
    ...state,
    isLottomatica,
  };
};

const handleSaveSurvey = (
  state: IConfigState,
  { surveyUrl }: { surveyUrl: string }
): IConfigState => {
  return {
    ...state,
    surveyUrl,
  };
};

const handleShowSurvey = (
  state: IConfigState,
  { abilitato }: { abilitato: boolean }
): IConfigState => {
  return {
    ...state,
    abilitato,
  };
};

const handleSaveConfig = (
  state: IConfigState,
  { config }: { config: Config }
): IConfigState => {
  return {
    ...state,
    ...config,
  };
};

const handleSaveRegexDhl = (
  state: IConfigState,
  {
    regexCodiceDhlInbound,
    regexCodiceDhlInboundCodeSeparator,
  }: {
    regexCodiceDhlInbound: string;
    regexCodiceDhlInboundCodeSeparator: string;
  }
): IConfigState => {
  return {
    ...state,
    regexCodiceDhlInbound,
    regexCodiceDhlInboundCodeSeparator,
  };
};

const handleSaveExpiredObject = (
  state: IConfigState,
  {
    frequenzaPopupOggettiScaduti,
    giornataLavorativa,
    numeroOgettiScadutiOggi,
    numeroOgettiScadutiPrimaDiOggi,
    oggettiScadutiOggi,
    oggettiScadutiPrimaDiOggi,
  }: {
    frequenzaPopupOggettiScaduti: number;
    giornataLavorativa: boolean;
    numeroOgettiScadutiOggi: number;
    numeroOgettiScadutiPrimaDiOggi: number;
    oggettiScadutiOggi: boolean;
    oggettiScadutiPrimaDiOggi: boolean;
  }
): IConfigState => {
  return {
    ...state,
    frequenzaPopupOggettiScaduti,
    giornataLavorativa,
    numeroOgettiScadutiOggi,
    numeroOgettiScadutiPrimaDiOggi,
    oggettiScadutiOggi,
    oggettiScadutiPrimaDiOggi,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_NOTIFICATIONS_SUCCESS, handleSaveNotifications),
  on(RETRIEVE_SURVEY_SUCCESS, handleSaveSurvey),
  on(RETRIEVE_SHOW_SURVEY, handleShowSurvey),
  on(RETRIEVE_REGEX_DHL_SUCCESS, handleSaveRegexDhl),
  on(RETRIEVE_EXPIRED_OBJECT_SUCCESS, handleSaveExpiredObject),
  on(SET_IS_LOTTOMATICA, handleSetIsLottomatica),
  on(RETRIEVE_CONFIG_SUCCESS, handleSaveConfig)
);

export const configReducer = (
  state: IConfigState | undefined,
  action: Action
): IConfigState => reducer(state, action);
